/* eslint-disable */
import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_API + "/excursion/bus-company/";


const state = {
    busCompanies: []
}

const actions = {
    async retrieveBusCompanies({
        commit,
        dispatch
    }, payload) {
        // retrieve bus companies list from bus application database        
        return axios
            .get(
                baseUrl
            )
            .then(response => {
                commit('SET_BUS_COMPANIES', response.data)
                return response.data
            })
    },
    async createBusCompany({
        commit, dispatch
    }, payload) {
        await axios
            .post(baseUrl, payload.payload)
            .then( response => {
                dispatch('retrieveBusCompanies')
                return response.data
            })
    },
    async updateBusCompany({
        commit, dispatch
    }, payload) {
        await axios
            .patch(baseUrl + payload.item_id + '/', payload.payload)
            .then( response =>  {
                dispatch('retrieveBusCompanies')
                return response.data
            })
    },
    async deleteBusCompany({
        commit, dispatch
    }, payload) {
        return axios.delete(baseUrl + payload.item_id + '/')
    }
}

const mutations = {
    SET_BUS_COMPANIES(state, bus_companies) {
        state.busCompanies = bus_companies
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}